module.exports = __webpack_public_path__ + "static/media/nakaz79.8b0582e3.pdf";